mutation DeleteComplianceRecord($id: ID!) {
  deleteComplianceRecord(id: $id)
}
